import React, { useRef } from 'react';
import styled from 'styled-components';

interface ProductShopVideoProps {
  videoUrl?: string;
}

const ProductShopVideo: React.FC<ProductShopVideoProps> = ({ videoUrl }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  return (
    <VideoWrap id="productVideo">
      {videoUrl && (
        <video
          ref={videoRef}
          width="270px"
          height="320px"
          autoPlay={false}
          controls={false}
          loop={true}
          muted={true}
          playsInline={true}
          data-testid="product-shop-video"
        >
          <source src={videoUrl} type="video/mp4" />
        </video>
      )}
    </VideoWrap>
  );
};

export default ProductShopVideo;

const VideoWrap = styled.div`
  display: none;
  position: relative;
  z-index: 2;
  height: 100%;
  min-width: 100%;

  & > a {
    height: 100%;
    min-width: 100%;

    & > video {
      height: 100%;
      min-width: 100%;
      object-fit: cover;
    }
  }
`;
